export default "/images/vendor/flag-icons/flags/1x1/al.svg?c05e63fb1dba6cd20026891fd9318af4";